import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import backgroundImage from '../assets/LOGO.png';
import { getMieterArray, postPDFs } from "../api";
import Animation from "../components/Animation";



function UploadPdfsPage() {
    const navigate = useNavigate();
    const { superUserId } = useParams();
    const superuserName = localStorage.getItem("username");
    const [loading, isLoading] = useState(false);
    const [title, setTitle] = useState("");
    const [file, setFile] = useState(null);
    const [mieterList, setMieterList] = useState([]);
    const [selectedMieter, setSelectedMieter] = useState("");

    useEffect(() => {
        const fetchMieter = async () => {
          const token = localStorage.getItem("token");
          try {
            const result = await getMieterArray(token);
            setMieterList(result);
            isLoading(false)
          } catch (error) {
            console.error("Fehler beim Laden der Mieter:", error);
            isLoading(false)
          }
        };
      
        fetchMieter(); // 👈 Don't forget to call it!
      }, []);
      
      const handleSubmit = async (e) => {
        e.preventDefault();
        isLoading(true)
        const token = localStorage.getItem("token");
        await new Promise((resolve) => setTimeout(resolve, 2000));
        // ✅ Validate required fields
        if (!title || !file || !selectedMieter || !superUserId) {
          alert("Bitte füllen Sie alle Felder aus.");
          return;
        }
      
        const formData = new FormData();
        formData.append("title", title);
        formData.append("file", file);
        formData.append("mieters", selectedMieter);  // send only one Mieter ID
        formData.append("user", superUserId);
      
        try {
          await postPDFs(formData, token);
          alert("PDF erfolgreich hochgeladen!");
      
          // Reset fields
          setTitle("");
          setFile(null);
          setSelectedMieter("");
          isLoading(false)
        } catch (error) {
          console.error("Fehler beim Hochladen:", error);
          isLoading(false)
          alert("Upload fehlgeschlagen.");
        }
      };
      

    return (
      <div style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'contain', // or 'cover' depending on preference
        minHeight: '100vh',
        padding: '2rem',
        overflowY: 'auto'
      }}>
            <h1>Regelmäßiges Uploaden von PDFs einfach gemacht :D</h1>
            <h2>Willkommen, {superuserName}!</h2>

            <form onSubmit={handleSubmit}>
                <div>
                    <label>PDF-Titel:</label><br/>
                    <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
                </div>

                <div>
                    <label>Datei hochladen:</label><br/>
                    <input
  type="file"
  accept="application/pdf"
  onChange={(e) => {
    setFile(e.target.files[0]);
  }}
  required
/>
{file && <p>Ausgewählte Datei: {file.name}</p>}

                </div>
                

                <div>
                    <label>Mieter auswählen:</label><br/>
                    <select value={selectedMieter} onChange={(e) => setSelectedMieter(e.target.value)} required>

                        <option value="">-- bitte wählen --</option>
                        {mieterList.map((mieter) => (
                            <option key={mieter.id} value={mieter.id}>{mieter.name || mieter.user}</option>
                        ))}
                    </select>
                </div>

                <button type="submit">PDF hochladen</button>
            </form>
             <Animation loading={loading}/>
        </div>
    );
}

export default UploadPdfsPage;